module.exports = __webpack_public_path__ + "static/img/shopping.82e1b26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopping.jpg
// module id = 35
// module chunks = 1